function getSiblings(elem) {
  return Array.from(elem.parentNode.children).filter(child => child !== elem);
}

function slideDown(el) {
  el.style.display = 'block';
  const height = el.scrollHeight + 'px';
  el.style.height = height;
}

function slideUp(el) {
  el.style.height = el.scrollHeight + 'px';
  requestAnimationFrame(() => {
    el.style.height = '0px';
  });

  el.addEventListener('transitionend', function handler() {
    el.style.display = 'none';
    el.removeEventListener('transitionend', handler);
  });
}

class CollapsibleManager {
  constructor() {
    document.body.addEventListener('click', e => {
      const toggle = e.target.closest('[data-action="toggle-collapsible"]:not([disabled])');
      if (toggle) {
        this._toggleCollapsible({ detail: { id: toggle.getAttribute('aria-controls') } }, toggle);
      }
    });

    document.addEventListener('collapsible:toggle', e => this._toggleCollapsible(e));
  }

  _toggleCollapsible(event, target) {
    if (!target && event.detail) {
      target = document.querySelector(`[aria-controls="${event.detail.id}"]`);
    }

    if (!target) return;

    const isOpen = target.getAttribute('aria-expanded') === 'true';
    const parentCollapsible = target.parentNode;

    if (isOpen) {
      this._close(parentCollapsible);
    } else {
      this._open(parentCollapsible);
    }

    if (target.getAttribute('data-close-siblings') !== 'false') {
      getSiblings(parentCollapsible).forEach(collapsible => this._close(collapsible));
    }
  }

  _open(collapsible) {
    const toggle = collapsible.querySelector('[aria-controls]');
    const content = document.getElementById(toggle.getAttribute('aria-controls'));
    toggle.setAttribute('aria-expanded', 'true');
    content.setAttribute('aria-hidden', 'false');
    slideDown(content);
  }

  _close(collapsible) {
    const toggle = collapsible.querySelector('[aria-controls]');
    const content = document.getElementById(toggle.getAttribute('aria-controls'));
    toggle.setAttribute('aria-expanded', 'false');
    content.setAttribute('aria-hidden', 'true');
    slideUp(content);
  }
}

new CollapsibleManager();